import React from 'react'
import GroupsList from '../../components/Groups/GroupsList.jsx'
import {user} from '../../core/controllers/user';

export default class GroupsTemplate extends React.Component { 
    render(){
        return (
            <div class="col-md-12">
                <div class="card">
                    <div class="header">
                        <h4 class="title">View/Edit Groups</h4>
                        <p class="category"></p>
                    </div>
                    <GroupsList data={[]}/>
                </div>
            </div>                
        )
    }
};


// WEBPACK FOOTER //
// app/views/Groups/Groups.jsx